var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.75,
    height: 21.752,
    viewBox: "0 0 21.75 21.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#091119",
    d: "M18.125 0h-14.5A3.625 3.625 0 0 0 0 3.625v16.917l.007.137a1.209 1.209 0 0 0 2.056.717l4.479-4.479h11.583a3.625 3.625 0 0 0 3.625-3.625V3.625A3.625 3.625 0 0 0 18.125 0z",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#091119",
    d: "M9.6 1a1.113 1.113 0 0 1 1.2-1A1.113 1.113 0 0 1 12 1a1.113 1.113 0 0 1-1.2 1 1.113 1.113 0 0 1-1.2-1zM4.8 1A1.114 1.114 0 0 1 6 0a1.114 1.114 0 0 1 1.2 1A1.114 1.114 0 0 1 6 2a1.114 1.114 0 0 1-1.2-1zM0 1a1.113 1.113 0 0 1 1.2-1 1.113 1.113 0 0 1 1.2 1 1.113 1.113 0 0 1-1.2 1A1.113 1.113 0 0 1 0 1z",
    transform: "translate(4.375 7.375)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.7b1df332b98afc96f9d57a62b0423685.svg";
export { ForwardRef as ReactComponent };